module.exports = __webpack_public_path__ + "img/package-cancel.5c77c24a.png";